var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.192,
    height: 22.909,
    viewBox: "0 0 22.192 22.909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-notes",
    transform: "translate(-112.23 -74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M616.648,1156.212a.692.692,0,0,0-.692-.692h-8.724a.692.692,0,1,0,0,1.384h8.724A.692.692,0,0,0,616.648,1156.212Z",
    transform: "translate(-489.677 -1071.382)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M607.462,1560.1a.692.692,0,1,0,0,1.383h6.98a.692.692,0,1,0,0-1.383Z",
    transform: "translate(-489.904 -1472.17)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M611.492,1965.25h-4.02a.692.692,0,1,0,0,1.383h4.02a.692.692,0,1,0,0-1.383Z",
    transform: "translate(-489.914 -1873.522)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M121.348,95.525H116a2.386,2.386,0,0,1-2.383-2.383V81.725h16.6v1.63a.692.692,0,0,0,1.384,0v-4.8a3.771,3.771,0,0,0-3.767-3.767h-.516v-.092a.692.692,0,0,0-1.384,0v.092H122.61v-.092a.692.692,0,0,0-1.384,0v.092H117.9v-.092a.692.692,0,0,0-1.384,0v.092H116a3.771,3.771,0,0,0-3.767,3.767V93.142A3.771,3.771,0,0,0,116,96.909h5.35a.692.692,0,1,0,0-1.384Zm-7.733-16.974A2.386,2.386,0,0,1,116,76.168h.518v.1a.692.692,0,0,0,1.384,0v-.1h3.326v.1a.692.692,0,0,0,1.384,0v-.1h3.326v.1a.692.692,0,0,0,1.384,0v-.1h.516a2.386,2.386,0,0,1,2.383,2.383v1.791h-16.6Z",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M1289.58,1276.906a2.621,2.621,0,0,0-3.7,0l-6.023,6.024a1.363,1.363,0,0,0-.387.747l-.356,2.109a1.379,1.379,0,0,0,1.361,1.609,1.359,1.359,0,0,0,.229-.019l2.107-.356a1.375,1.375,0,0,0,.747-.385l6.026-6.026a2.621,2.621,0,0,0,0-3.7Zm-7,8.749-2.1.362.355-2.107,4.212-4.213,1.746,1.746-4.211,4.211Zm6.023-6.024-.834.834-1.746-1.746.834-.835a1.235,1.235,0,0,1,1.746,1.746Z",
    transform: "translate(-1155.923 -1190.871)",
    fill: "#0000b5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotes);
export default __webpack_public_path__ + "static/media/icon-notes.de42b830e4a01d4122cb3700c645fb7d.svg";
export { ForwardRef as ReactComponent };